import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function rowFieldValue(obj, path, fallback = null, formatter = null) {
  if(!obj || !path) {
    return null
  }
  const value = path
    .split('.')
    .reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj)

  if (value !== undefined) {
    return formatter ? formatter(value) : value
  }
  return fallback
}
